import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { useDispatch, useSelector } from 'react-redux';
import config from 'react-global-configuration';
import { viewGetInfo } from '../../../../redux/actions/Entity/View';
var ViewFilters = function ViewFilters(_ref) {
  var viewId = _ref.viewId,
    display = _ref.display,
    onFilterUpdate = _ref.onFilterUpdate,
    onResetFilter = _ref.onResetFilter,
    onRender = _ref.onRender;
  var dispatch = useDispatch();
  var filters = useSelector(function (state) {
    return state.getIn(['viewInfo', viewId, 'display', display, 'display_options', 'filters'], Immutable.Map());
  });
  var language = useSelector(function (state) {
    return state.getIn(['ui', 'language'], config.get('DEFAULT_LANGUAGE'));
  });
  useEffect(function () {
    dispatch(viewGetInfo(viewId));
  }, [dispatch, viewId, language]);
  var updateFilter = function updateFilter(field, value) {
    onFilterUpdate(field, value);
  };
  var defaultRender = function defaultRender(props) {
    console.log('!! Element not implemented', props);
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "View__filters"
  }, filters && filters.valueSeq().filter(function (filter) {
    return filter.get('exposed', false) === true;
  }).map(function (filter, i) {
    return /*#__PURE__*/React.createElement(ViewFilterElement, {
      key: filter.get('field'),
      filter: filter,
      onChange: updateFilter,
      onReset: onResetFilter,
      onRender: onRender || defaultRender
    });
  }));
};
var ViewFilterElement = function ViewFilterElement(props) {
  // This is just a pass-through element.
  return props.onRender(props);
};
export default ViewFilters;